import Exercise from '@/api/exercise';
import Lesson from '@/api/lesson';
import { safeLock } from '../common/util';

import { copyConversationContent } from './conversation-content';
import { copySpeakingContent } from './speaking-content';
import { copyListeningContent } from './listening-content';

export const copyExercise = async (
  exercise: Exercise,
  targetLesson: number
) => {
  const newExercise = await safeLock(Lesson.SLUG, targetLesson, async () => {
    const newExercise = new Exercise(exercise.game_type);
    newExercise.game_type = exercise.game_type;
    newExercise.parent_lesson = targetLesson;
    newExercise.intelligibility_ready = exercise.intelligibility_ready;
    newExercise.isDirty = exercise.isDirty;
    newExercise.bg_image = exercise.bg_image;
    newExercise.bg_image_link = exercise.bg_image_link;
    newExercise.bg_image_path = exercise.bg_image_path;
    newExercise.insight_info = exercise.insight_info;

    await newExercise.save();
    return newExercise;
  });

  await safeLock(Exercise.SLUG, newExercise.id, async () => {
    await copyConversationContent(newExercise, exercise.conversation_content);
    await copySpeakingContent(newExercise, exercise.speaking_content);
    await copyListeningContent(newExercise, exercise.listening_content);

    return 0;
  });
};
